import Cookies from 'js-cookie';
const app = {
  state: {
    aucRules: Cookies.getJSON('zy-live-paas-web-aucRules'),
    shopId: Cookies.getJSON('zy-live-paas-web-shopId'),
    token: null, // 因为这些参数是小程序URL链接里面带的，所以不用存Cookies
    qiniuToken: null,
    userinfos: null,
    isActivity:
      new Date().getTime() > new Date(1655308800000).getTime() &&
      new Date().getTime() < new Date(1655827200000).getTime(),
    adBanner: null,
    ycUserinfos: window.localStorage.getItem('ycUserinfos'),
  },

  mutations: {
    setAucRules(state, data) {
      state.aucRules = data;
      Cookies.set('zy-live-paas-web-aucRules', data);
    },
    setShopId(state, data) {
      state.shopId = data;
      Cookies.set('zy-live-paas-web-shopId', data);
    },
    setToken(state, data) {
      state.token = data;
    },
    setAdBanner(state, data) {
      state.adBanner = data;
    },
    setQiniuToken(state, data) {
      state.qiniuToken = data;
    },
    setUserinfo(state, data) {
      state.userinfos = data;
    },
  },

  actions: {
    setAdBanner({ commit }, data) {
      commit('setAdBanner', data);
    },
    setAucRules({ commit }, data) {
      commit('setAucRules', data);
    },
    setShopId({ commit }, data) {
      commit('setShopId', data);
    },
    setToken({ commit }, data) {
      commit('setToken', data);
    },
    setQiniuToken({ commit }, data) {
      commit('setQiniuToken', data);
    },
    setUserinfo({ commit }, data) {
      commit('setUserinfo', data);
    },
  },
};
export default app;
